import { render, staticRenderFns } from "./RegistroHorasHome.vue?vue&type=template&id=0cf910d1&scoped=true&"
import script from "./RegistroHorasHome.vue?vue&type=script&lang=js&"
export * from "./RegistroHorasHome.vue?vue&type=script&lang=js&"
import style0 from "./RegistroHorasHome.vue?vue&type=style&index=0&id=0cf910d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf910d1",
  null
  
)

export default component.exports